var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "sub-menu",
      staticStyle: { "margin-bottom": "15px" },
      attrs: {
        "slider-color": "primary",
        height: "64",
        "background-color": "transparent"
      }
    },
    [
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/optima/settings/category" }
        },
        [
          _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
            _vm._v("fa-columns")
          ]),
          _vm._v(" " + _vm._s(_vm.$t("optima.category")) + " ")
        ],
        1
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/optima/settings/employee" }
        },
        [
          _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
            _vm._v("fa-address-book")
          ]),
          _vm._v(" " + _vm._s(_vm.$t("optima.employee")) + " ")
        ],
        1
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/optima/settings/contractor" }
        },
        [
          _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
            _vm._v("fa-address-card")
          ]),
          _vm._v(" " + _vm._s(_vm.$t("optima.contractor")) + " ")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }